import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const getFinancialHealth = async (communityId: string | number, fiscalYear: string | number) => {
  return await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/${fiscalYear}/financial-health`);
};

const useGetFinancialHealth = ({communityId, fiscalYear}: {communityId?: string | number, fiscalYear?: string | number}) =>
  useQuery({
    queryKey: ["financial-health", communityId, fiscalYear],
    queryFn: () => getFinancialHealth(communityId!, fiscalYear!),
    select: (data: any) => data.data,
    enabled: !!communityId && !!fiscalYear,
  });

export default useGetFinancialHealth;